import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  const socialLinks = [
    {
      label: "X",
      href: "https://twitter.com/PnL_Lucci",
    },
  ];

  const getIcon = (label) => {
    if (label === "X") {
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.64l-5.207-6.8-5.97 6.8H2.42l7.723-8.835L1.254 2.25h6.554l4.713 6.231 5.743-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      );
    }
  };

  return (
    <footer id="contact" className={styles.footer}>
      <div className={styles.container}>
        <p className={`${styles.tagline} mono`}>
          Always Building, Always Evolving.
        </p>

        <div className={styles.links}>
          {socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
              title={link.label}
            >
              {getIcon(link.label)}
            </a>
          ))}
        </div>

        <p className={`${styles.copyright} mono`}>© 2026 Lucas</p>
      </div>
    </footer>
  );
};

export default Footer;
